/* import __COLOCATED_TEMPLATE__ from './market-field-with-input-hint.hbs'; */
import Component from '@glimmer/component';
export default class MarketFieldWithInputHint extends Component {
  get error() {
    return this.args.inputHintDescription?.error;
  }
  get isInvalid() {
    return Boolean(this.error);
  }
  get helper() {
    return this.args.inputHintDescription?.helper;
  }
}